// Best-effort, keyless reverse geo-IP so active sessions can show a friendly "City, CC" and flag
// logins from an unfamiliar country. Never blocks the UI — on any failure it returns null and the
// caller falls back to the raw IP. Results are cached per-IP for the page session.
const cache = new Map();

function isPrivate(ip) {
  if (!ip) return true;
  return /^(10\.|127\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|::1|fe80:|fc00:|localhost)/i.test(ip);
}

// Returns { label: "City, CC", cc: "US" } or null.
export async function lookupGeo(ip) {
  if (isPrivate(ip)) return null;
  if (cache.has(ip)) return cache.get(ip);
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 4000);
    const res = await fetch(`https://ipwho.is/${ip}?fields=success,city,country_code`, { signal: ctrl.signal });
    clearTimeout(timer);
    const d = await res.json();
    const cc = d?.success ? d.country_code || null : null;
    const label = d?.success ? [d.city, cc].filter(Boolean).join(", ") : null;
    const val = label ? { label, cc } : null;
    cache.set(ip, val);
    return val;
  } catch {
    cache.set(ip, null);
    return null;
  }
}
